export const SET_ROLE_LIST = 'role/set-role-list';
export const SET_MORE_ROLE_LIST = 'role/set-more-role-list';
export const SET_ROLE_DATA = 'role/set-role-data';
export const SET_DND_ROLE_DATA = 'role/set-dnd-role-data';
